var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 38H240V128H80V38Z",
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 42H84V124H236V42ZM80 38V128H240V38H80Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.074 105V93.8498L117.42 82.8998L133.074 71.9499V61L108 79.7618V86.305L133.074 105Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.926 105V93.8498L202.58 82.8998L186.926 71.9499V61L212 79.7618V86.305L186.926 105Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148 98.4072H157.768L172 67.4072H162.232L148 98.4072Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 26,
    width: 160,
    height: 16,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFrame);
export default __webpack_public_path__ + "static/media/i-frame.7a7d2abe98ce5ec1b993fdcad535109f.svg";
export { ForwardRef as ReactComponent };